import createColor from 'color';
export { default as createColor } from 'color';

function hasAlpha(color) {
  return color.startsWith("rgba(") || color.startsWith("hsla(") || color.startsWith("#") && color.length === 9 || color.startsWith("#") && color.length === 5;
}
function hexToRgbaArray(color) {
  const [r, g, b, a] = createColor(color).rgb().array();
  return [r, g, b, a === void 0 && hasAlpha(color) ? 1 : a];
}
function hexToRgba(color, alphaValue) {
  const [r, g, b] = hexToRgbaArray(color);
  return `rgba(${r}, ${g}, ${b}, ${alphaValue})`;
}
function rgbaToHex(color) {
  return createColor(color).hex();
}
function lighten(color, ratio, colorValueType = "hex") {
  const lightenColor = createColor(color).lighten(ratio);
  if (colorValueType === "hex") {
    return lightenColor.hex();
  }
  return lightenColor.rgb().toString();
}
function darken(color, ratio, colorValueType = "hex") {
  const darkenColor = createColor(color).darken(ratio);
  if (colorValueType === "hex") {
    return darkenColor.hex();
  }
  return darkenColor.rgb().toString();
}

export { darken, hexToRgba, lighten, rgbaToHex };
//# sourceMappingURL=colorUtils.mjs.map
